module.exports = __webpack_public_path__ + "img/routes_create_dark.eb89dc9f.gif";